import Vue from 'vue';
import moment from 'moment';

Vue.filter('abrev', (value) => {
  if (!value) return '';
  let initials = value.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  return initials;
});

Vue.filter('capitalize', (value) => {
  if (!value) return '';
  value = value.toString();
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
});

Vue.filter('weightToKG', (value) => {
  if (!value) return '';
  value = value.toString();
  return `${value}kg`;
});

Vue.filter('heightToCM', (value) => {
  if (!value) return '';
  value = Math.round((+value + Number.EPSILON) * 100) / 100;
  value = value.toFixed(1);
  return `${value}cm`;
});

Vue.filter('currency', (value) => `${value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`);

Vue.filter('now', (value) => {
  if (!value) return '';
  return moment(value).locale('pt-br').fromNow(true);
});
